import axios from '../Utility/axiosconfig'

const getShippingAmount = async (body) => {
    let { data } = await axios.post('auctionpay/getshippingrates', body)
    try {
        if (data.success) {
            return {
                data: data.data,
            }
        } else {
            return 'Something went wrong'
        }
    } catch (err) {
        return 'Something went wrong'
    }
}

export default getShippingAmount
